'use client';

import { Award, CheckCircle2, FileText } from "lucide-react";
import { PartnershipForm } from "./PartnershipForm";

export function PartnershipHero() {
  return (
    <section className="relative isolate overflow-hidden bg-slate-950 text-white">
      {/* Background image + gradient overlay */}
      <div className="absolute inset-0">
        {/* Replace this with your actual image URL */}
        <div className="absolute inset-0 bg-[url('/images/campus-placeholder.jpg')] bg-cover bg-center opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#00406b] via-[#00406b]/90 to-[#f5c15f]/70" />
      </div>

      <div className="relative max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto py-10 md:py-16 lg:py-20">
        <div className="grid gap-10 lg:gap-14 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)] items-center">
          {/* LEFT: Content */}
          <div className="space-y-7 md:space-y-8">
            {/* Badge */}
            <div className="inline-flex items-center gap-3 rounded-full bg-white/10 px-4 py-2 backdrop-blur-md border border-white/15 shadow-lg">
              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#F5C15F]/10">
                <Award className="h-5 w-5 text-[#F5C15F]" />
              </div>
              <div className="text-xs md:text-sm leading-snug">
                <p className="font-semibold">India&apos;s 1st University to Promote NEP2020</p>
                <p className="text-white/80">In an industry-led format</p>
              </div>
            </div>

            {/* Heading */}
            <div>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight">
                Tie Up to{" "}
                <span className="text-white">Skill Up</span>
                <br />
                <span className="text-[#F5C15F]">and Scale Up</span>
              </h1>
              <p className="mt-3 md:mt-4 text-sm md:text-base text-sky-50/90 max-w-xl">
                Partner with an industry-led university to co-create skill-based programs,
                access emerging talent, and unlock powerful apprenticeship benefits.
              </p>
            </div>

            {/* Bullet list */}
            <ul className="space-y-3 text-sm md:text-base">
              <BulletPoint
                highlight="UGC"
                text="Recognized Higher Education Programs"
              />
              <BulletPoint
                highlight="NCVET"
                text="Certified Specialized Skill Courses"
              />
              <BulletPoint
                text="Upskilling aligned with emerging industry trends"
              />
              <BulletPoint
                text="Financial incentives for trainees through apprenticeship programs"
              />
              <BulletPoint
                highlight="GOI"
                text="supported initiatives for on-the-job skilling"
              />
            </ul>

            {/* CTA Button */}
            {/* <div className="pt-3">
              <button
                type="button"
                className="inline-flex items-center gap-3 rounded-full bg-[#F5A700] px-6 md:px-8 py-3 text-sm md:text-base font-semibold text-slate-950 shadow-[0_14px_30px_rgba(0,0,0,0.35)] hover:bg-[#ffb61c] transition transform hover:-translate-y-0.5"
              >
                <span className="flex h-8 w-8 items-center justify-center rounded-full   border-white/30">
                  <FileText className="h-4 w-4" />
                </span>
                <span>Download Brochure</span>
              </button>
            </div> */}
          </div>

          {/* RIGHT: Form card */}
          <div className="lg:justify-self-end">
            <PartnershipForm />
          </div>
        </div>
      </div>
    </section>
  );
}

/* ---------- Small reusable components ---------- */

function BulletPoint({ highlight, text }) {
  return (
    <li className="flex items-start gap-3">
      <span className="mt-0.5">
        <CheckCircle2 className="h-5 w-5 text-[#F5C15F]" />
      </span>
      <p className="text-sm md:text-base">
        {highlight && <span className="font-semibold text-[#F5C15F]">{highlight} </span>}
        <span className="text-sky-50/95">{text}</span>
      </p>
    </li>
  );
}
